import React from 'react';

const DropDown = ({order}) => {
    const handleClick = (id, value) => {
        fetch('https://assignment-11-samiun.herokuapp.com/updateOrder/' + id, {
            method: 'PATCH',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({state: value})
        })
    }
    
    return (
        <div className="dropdown" style={{width: '150px', marginBottom: '35px'}}>
                      <div className={`alert alert-${order.state} dropdown-toggle`} href="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                      </div>
                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                            <li onClick={() => handleClick(order._id, 'done')}><div className="dropdown-item alert alert-done"></div></li>
                            <li onClick={() => handleClick(order._id, 'ongoing')}><div className="dropdown-item alert alert-ongoing"></div></li>
                            <li onClick={() => handleClick(order._id, 'pending')}><div className="dropdown-item alert alert-pending"></div></li>
                        </ul>
        </div>
    );
};

export default DropDown;